export default __webpack_public_path__ + "static/media/usa.d38b1cc7.png";